import { render, staticRenderFns } from "./PhpMyAdminSsoModal.vue?vue&type=template&id=5365418d&scoped=true"
import script from "./PhpMyAdminSsoModal.vue?vue&type=script&lang=js"
export * from "./PhpMyAdminSsoModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=5365418d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365418d",
  null
  
)

export default component.exports